export const allWords = 100000;
export const commonWords = 47000;
export const baseWords = 6500;
export const foundamentalWords = 2000;

export const coffeeWords = 2000;
export const giornaleLowWords = 800;
export const giornaleHighWords = 1200;
